import React, {useState} from "react";
import strapi from "/scripts/apis/strapi/index.js";
import marked from "/scripts/marked/index.js";
import css from "./index.module.scss";
import DefaultLayout from "layouts/default";
import ImageCard from "@/components/imageCard";
import Button from "@/components/button";
import TrashSvg from "/public/images/icons/trash.svg";
import Tag from "@/components/tag/index.jsx";
import { StrapiPicture } from "@/components/picture";
import { useEffect } from "react";
import { getCart, removeFromCart } from "@/scripts/utils";
import { useUser } from "@/scripts/apis/site/useUser";
import Checkbox from "@/components/checkbox";
import Link from "next/link";
import { useRouter } from "next/router";

export default function CartPage({}) {
  const [cart, setCart] = useState(null);
  const user = useUser();
  const router = useRouter();
  const [message, setMessage] = useState("");
  const [termsAccepted, setTermsAccepted] = useState(false);

  useEffect(() => {
    setCart(getCart());
  }, []);

  function removeListing(id){
    setCart(removeFromCart(id));
  }

  async function checkout(){
    //can only checkout if logged in
    if (!user?.value?.id){
      router.push("/auth/register?ref=/account/cart");
      return;
    }

    //immediately grant any free listings
    let freeListings = Object.entries(cart?.listings || {})
      .filter((entry) => entry[1].price === "0.00" && !entry[1].stripeProductId)
      .map((entry) => entry[1]);


    for (let listing of freeListings){
      let res = await strapi.query(strapi.endpoints.PURCHASES_ME_CREATE, {
        data: {
          listing: listing.id,
        },
      });
    }

    //open stripe checkout for paid listings
    let stripeListings = Object.entries(cart?.listings || {})
      .filter((entry) => entry[1].price !== "0.00" || entry[1].stripeProductId)
      .map((listing) => listing[1].id);

    if (stripeListings.length > 0){
      let res = await strapi.query(strapi.endpoints.USER_ME_CHECKOUT, {
        data: {
          listings: stripeListings,
          freeListings,
        },
      });

      if (res.url){
        router.push(res.url);
        return;
      }

      setMessage("Error connecting to Stripe. Please try again later.");
    } else {
      router.push(`/account/checkout/success?ids=${freeListings.map((listing) => listing.id).join(",")}`);
    }
  }

  //convert the listing dict into an array
  let listings = Object.entries(cart?.listings || {}).map((listing) => listing[1]);
  return <DefaultLayout
    title="Cart | Lazy Prompts"
    description="Buy and sell AI prompts."
    light
  >
    <section className={`light ${css.cart}`}>
      <div className="sectionInner">
        <h2>Cart</h2>
        {listings.length > 0 && <div className={css.listings}>
          {listings.map((listing) => <div key={listing.id} className={css.listing}>
            <ImageCard
              light
              className={css.image}
              strapiPicture={listing.coverArt}
              sizes="(max-width: 1300px) 50vw, (max-width:650px) 100vw, 25vw"
            />
            <div className={css.identification}>
              <div className={css.name}>{listing.name}</div>
              <div className={css.id}>Listing #{listing.id}</div>
            </div>
            <div className={css.price}>{listing.price}</div>
            <div className={css.controls}>
              <Button onClick={() => removeListing(listing.id)} label={null} ghost grayscale light icon={<TrashSvg/>} className={css.trash}/>
            </div>
          </div>)}
          <div className={css.checkout}>
            <div className={css.buttons}>
              <Checkbox label={<div>I agree to the <Link href="/legal/terms-and-conditions"><a target="_blank">terms of service</a></Link> and the <Link href="/legal/refund-policy"><a target="_blank">refund policy</a></Link>.</div>} onChange={setTermsAccepted}/>
              <Button label="Checkout" onClick={checkout} disabled={!termsAccepted}/>
            </div>
            {message && <div>{message}</div>}
          </div>
        </div>}

        {listings.length === 0 && <>
          <div className={css.notification}>Your cart is empty.</div>
          <Button href="/listings" label="Shop"/>
        </>}
      </div>
    </section>

  </DefaultLayout>;
}
